// LUMINA · components/ProfileSelector.jsx
// Phase 104 — 排盘表单中的档案选择下拉

import React, { useState, useEffect } from 'react';
import { C } from '../constants/baziData';

const API = "/api";

export default function ProfileSelector({ onSelect, lang }) {
  const [profiles, setProfiles] = useState([]);
  const [selected, setSelected] = useState("");

  useEffect(() => {
    const t = localStorage.getItem("lumina_token");
    if (!t) return;
    fetch(`${API}/profiles`, {
      headers: { "Authorization": `Bearer ${t}`, "Content-Type": "application/json" }
    })
      .then(r => r.ok ? r.json() : [])
      .then(data => setProfiles(data))
      .catch(() => {});
  }, []);

  const handleSelect = (e) => {
    const id = e.target.value;
    setSelected(id);
    if (!id) return;
    const p = profiles.find(x => x.id === id);
    if (p) onSelect(p);
  };

  if (profiles.length === 0) return null;

  const zh = lang === "zh";

  return (
    <div style={{ marginBottom: 16, maxWidth: 520 }}>
      <div style={{ fontSize: 11, color: C.mist4, marginBottom: 4, letterSpacing: ".04em" }}>
        {zh ? "从档案加载" : "Load from profile"}
      </div>
      <select
        value={selected}
        onChange={handleSelect}
        style={{
          width: "100%", padding: "10px 12px", fontSize: 14,
          border: "1px solid rgba(212,175,55,.25)", borderRadius: 8,
          background: "rgba(255,255,255,.9)", color: C.mist,
          fontFamily: "'Noto Sans SC','PingFang SC','Inter',sans-serif",
        }}
      >
        <option value="">{zh ? "-- 选择档案快速填充 --" : "-- Select profile to fill --"}</option>
        {profiles.map(p => (
          <option key={p.id} value={p.id}>
            {p.gender === "male" ? "👤" : "👩"} {p.name}
            {" · "}{p.birth_year}/{String(p.birth_month).padStart(2, '0')}/{String(p.birth_day).padStart(2, '0')}
            {p.is_primary ? (zh ? " [主]" : " [primary]") : ""}
          </option>
        ))}
      </select>
    </div>
  );
}
